module.exports = "/fonts/Gineso-Norm-Regular.eot";